export interface Drama {
  id: string;
  title: string;
  category: string;
  categorySlug: string;
  image: string;
  rating: number;
  year: number;
  region: string;
  episodes: string;
  status: string;
  description: string;
  actors: string[];
  director: string;
  isHot: boolean;
  isNew: boolean;
  updateInfo: string;
  tags: string[];
}

export const categories = [
  { name: '热门推荐', slug: 'hot' },
  { name: '国产剧', slug: 'chinese' },
  { name: '韩剧', slug: 'korean' },
  { name: '美剧', slug: 'american' },
  { name: '日剧', slug: 'japanese' },
  { name: '综艺', slug: 'variety' },
  { name: '动漫', slug: 'anime' },
];

export const dramas: Drama[] = [
  {
    id: 'drama-1',
    title: '长安十二时辰',
    category: '国产剧',
    categorySlug: 'chinese',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20drama%20poster%20with%20warrior%20in%20Tang%20dynasty%20armor%20holding%20sword%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20dark%20moody%20background%20with%20ancient%20city%20silhouette%2C%20historical%20epic%20film%20poster%20style&width=600&height=800&seq=drama-changan-01&orientation=portrait',
    rating: 8.3,
    year: 2019,
    region: '中国大陆',
    episodes: '48集全',
    status: '已完结',
    description: '唐朝天宝三年，上元节前夕，长安城陷入危机。死囚张小敬临危受命，与少年名士李必携手在十二时辰内拯救长安。该剧以精致的服化道和紧凑的剧情，再现了盛唐时期的繁华与危机。',
    actors: ['雷佳音', '易烊千玺', '周一围', '热依扎'],
    director: '曹盾',
    isHot: true,
    isNew: false,
    updateInfo: '已完结',
    tags: ['古装', '悬疑', '历史', '动作'],
  },
  {
    id: 'drama-2',
    title: '狂飙',
    category: '国产剧',
    categorySlug: 'chinese',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20poster%20featuring%20police%20officer%20in%20dark%20suit%20standing%20against%20rainy%20city%20street%2C%20neo-noir%20cinematic%20style%2C%20intense%20mood%2C%20film%20poster%20aesthetic%20with%20red%20and%20black%20tones&width=600&height=800&seq=drama-kuangbiao-02&orientation=portrait',
    rating: 8.5,
    year: 2023,
    region: '中国大陆',
    episodes: '39集全',
    status: '已完结',
    description: '一部横跨二十年的扫黑除恶题材电视剧，讲述了刑警安欣与黑恶势力高启强之间长达二十年的正邪较量，展现了中国基层治理的艰难历程。',
    actors: ['张译', '张颂文', '李一桐', '张志坚'],
    director: '徐纪周',
    isHot: true,
    isNew: false,
    updateInfo: '已完结',
    tags: ['犯罪', '剧情', '扫黑', '年代'],
  },
  {
    id: 'drama-3',
    title: '繁花',
    category: '国产剧',
    categorySlug: 'chinese',
    image: 'https://readdy.ai/api/search-image?query=Shanghai%201990s%20nostalgic%20drama%20poster%2C%20elegant%20man%20in%20vintage%20suit%20walking%20on%20neon-lit%20Bund%20street%2C%20golden%20warm%20tones%2C%20Wong%20Kar-wai%20cinematic%20aesthetic%2C%20romantic%20retro%20film%20poster&width=600&height=800&seq=drama-fanhua-03&orientation=portrait',
    rating: 8.7,
    year: 2023,
    region: '中国大陆',
    episodes: '30集全',
    status: '已完结',
    description: '九十年代的上海，阿宝凭借改革开放的春风和自己的打拼，成为商界冉冉升起的新星。黄河路上，人人都在争一口气，人人都在书写自己的传奇。',
    actors: ['胡歌', '马伊琍', '唐嫣', '辛芷蕾'],
    director: '王家卫',
    isHot: true,
    isNew: false,
    updateInfo: '已完结',
    tags: ['都市', '商战', '年代', '爱情'],
  },
  {
    id: 'drama-4',
    title: '庆余年第二季',
    category: '国产剧',
    categorySlug: 'chinese',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20drama%20poster%20with%20young%20scholar%20in%20flowing%20robes%20holding%20ancient%20book%2C%20dramatic%20clouds%20and%20palace%20in%20background%2C%20epic%20wuxia%20film%20poster%20style%2C%20warm%20golden%20lighting&width=600&height=800&seq=drama-qingyunian-04&orientation=portrait',
    rating: 8.9,
    year: 2024,
    region: '中国大陆',
    episodes: '更新至36集',
    status: '热播中',
    description: '范闲从上一季的危机中脱身后，继续在南庆朝廷中周旋。面对更加复杂的朝堂局势和身世之谜，他必须步步为营，揭开层层迷雾。',
    actors: ['张若昀', '李沁', '陈道明', '吴刚'],
    director: '孙皓',
    isHot: true,
    isNew: true,
    updateInfo: '今日更新2集',
    tags: ['古装', '权谋', '奇幻', '武侠'],
  },
  {
    id: 'drama-5',
    title: '黑暗荣耀',
    category: '韩剧',
    categorySlug: 'korean',
    image: 'https://readdy.ai/api/search-image?query=Korean%20drama%20poster%20with%20elegant%20woman%20in%20black%20dress%20standing%20in%20front%20of%20moonlit%20cherry%20blossoms%2C%20dark%20aesthetic%2C%20revenge%20thriller%20film%20poster%20style%2C%20cold%20blue%20and%20white%20tones&width=600&height=800&seq=drama-glory-05&orientation=portrait',
    rating: 8.8,
    year: 2023,
    region: '韩国',
    episodes: '16集全',
    status: '已完结',
    description: '年少时遭受校园暴力的文东恩，经过多年精心策划，对当年的施暴者和旁观者展开了一场精心设计的复仇。这是一部关于正义与救赎的暗黑剧作。',
    actors: ['宋慧乔', '李到晛', '林智妍', '郑成日'],
    director: '安吉镐',
    isHot: false,
    isNew: false,
    updateInfo: '已完结',
    tags: ['复仇', '悬疑', '校园', '剧情'],
  },
  {
    id: 'drama-6',
    title: '鱿鱼游戏第二季',
    category: '韩剧',
    categorySlug: 'korean',
    image: 'https://readdy.ai/api/search-image?query=Korean%20thriller%20drama%20poster%20with%20masked%20figures%20in%20colorful%20playground%20setting%2C%20surreal%20and%20ominous%20atmosphere%2C%20iconic%20circle%20triangle%20square%20masks%2C%20dark%20film%20poster%20style&width=600&height=800&seq=drama-squid-06&orientation=portrait',
    rating: 8.6,
    year: 2024,
    region: '韩国',
    episodes: '更新至7集',
    status: '热播中',
    description: '成奇勋在赢得鱿鱼游戏后，决心揭露组织背后的真相。他再次踏入这场致命的游戏，却发现游戏的规模远超想象，背后的势力更加复杂。',
    actors: ['李政宰', '李秉宪', '魏嘏隽', '孔刘'],
    director: '黄东赫',
    isHot: true,
    isNew: true,
    updateInfo: '今日更新1集',
    tags: ['悬疑', '惊悚', '剧情', '生存'],
  },
  {
    id: 'drama-7',
    title: '绝命毒师',
    category: '美剧',
    categorySlug: 'american',
    image: 'https://readdy.ai/api/search-image?query=American%20drama%20poster%20with%20middle-aged%20man%20in%20yellow%20hazmat%20suit%20standing%20in%20desert%20landscape%2C%20dramatic%20sky%2C%20iconic%20crime%20series%20film%20poster%20style%2C%20warm%20desert%20tones&width=600&height=800&seq=drama-breakingbad-07&orientation=portrait',
    rating: 9.6,
    year: 2008,
    region: '美国',
    episodes: '62集全(共5季)',
    status: '已完结',
    description: '一位普通的高中化学老师在得知自己身患绝症后，为了给家人留下财产，开始利用自己的化学知识制造和贩卖冰毒，一步步走向罪恶的深渊。',
    actors: ['布莱恩·科兰斯顿', '亚伦·保尔', '安娜·冈', '迪恩·诺里斯'],
    director: '文斯·吉里根',
    isHot: false,
    isNew: false,
    updateInfo: '已完结',
    tags: ['犯罪', '剧情', '惊悚', '经典'],
  },
  {
    id: 'drama-8',
    title: '权力的游戏',
    category: '美剧',
    categorySlug: 'american',
    image: 'https://readdy.ai/api/search-image?query=Epic%20fantasy%20drama%20poster%20with%20iron%20throne%20made%20of%20swords%20in%20dark%20castle%2C%20dragon%20silhouette%20in%20sky%2C%20medieval%20fantasy%20film%20poster%20style%2C%20dark%20and%20dramatic&width=600&height=800&seq=drama-got-08&orientation=portrait',
    rating: 9.3,
    year: 2011,
    region: '美国',
    episodes: '73集全(共8季)',
    status: '已完结',
    description: '在虚构的维斯特洛大陆上，几大家族为争夺铁王座展开残酷的权力斗争。与此同时，远古的黑暗力量正在北方苏醒，威胁着整个大陆。',
    actors: ['艾米莉亚·克拉克', '基特·哈灵顿', '彼特·丁拉基', '琳娜·海蒂'],
    director: '大卫·贝尼奥夫',
    isHot: false,
    isNew: false,
    updateInfo: '已完结',
    tags: ['奇幻', '史诗', '权谋', '冒险'],
  },
  {
    id: 'drama-9',
    title: '非自然死亡',
    category: '日剧',
    categorySlug: 'japanese',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20medical%20drama%20poster%20with%20female%20forensic%20doctor%20in%20white%20coat%20in%20laboratory%20setting%2C%20clean%20modern%20aesthetic%2C%20soft%20lighting%2C%20Japanese%20drama%20film%20poster%20style&width=600&height=800&seq=drama-unnatural-09&orientation=portrait',
    rating: 9.4,
    year: 2018,
    region: '日本',
    episodes: '10集全',
    status: '已完结',
    description: '三澄美琴是一位在非自然死亡原因研究所工作的法医，她和同事们通过解剖遗体，揭露每一起非自然死亡背后的真相，为逝者发声。',
    actors: ['石原里美', '井浦新', '洼田正孝', '市川实日子'],
    director: '冢原亚由子',
    isHot: false,
    isNew: false,
    updateInfo: '已完结',
    tags: ['法医', '悬疑', '剧情', '职场'],
  },
  {
    id: 'drama-10',
    title: '重启人生',
    category: '日剧',
    categorySlug: 'japanese',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20slice%20of%20life%20drama%20poster%20with%20four%20young%20women%20friends%20smiling%20together%20in%20casual%20setting%2C%20warm%20natural%20lighting%2C%20heartwarming%20film%20poster%20style%2C%20soft%20pastel%20colors&width=600&height=800&seq=drama-brushup-10&orientation=portrait',
    rating: 9.1,
    year: 2023,
    region: '日本',
    episodes: '10集全',
    status: '已完结',
    description: '过着平凡生活的近藤麻美突然遭遇车祸离世。来到投胎咨询处后，她得知下辈子会投胎成为食蚁兽。为了转世为人，她决定重启自己的人生积攒阴德。',
    actors: ['安藤樱', '夏帆', '木南晴夏', '松坂桃李'],
    director: '水野格',
    isHot: false,
    isNew: false,
    updateInfo: '已完结',
    tags: ['奇幻', '喜剧', '人生', '友情'],
  },
  {
    id: 'drama-11',
    title: '大江大河之岁月如歌',
    category: '国产剧',
    categorySlug: 'chinese',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20poster%20with%20three%20men%20in%201990s%20Chinese%20business%20attire%20standing%20against%20industrial%20factory%20background%2C%20reform%20and%20opening%20up%20era%2C%20warm%20nostalgic%20film%20poster%20style&width=600&height=800&seq=drama-dajiang-11&orientation=portrait',
    rating: 8.4,
    year: 2024,
    region: '中国大陆',
    episodes: '更新至28集',
    status: '热播中',
    description: '以宋运辉、雷东宝、杨巡三人为代表的不同经济形态，在改革开放的大潮中继续书写各自的奋斗篇章。时代变迁中，每个人都在寻找属于自己的路。',
    actors: ['王凯', '杨烁', '董子健', '杨采钰'],
    director: '孔笙',
    isHot: false,
    isNew: true,
    updateInfo: '今日更新2集',
    tags: ['年代', '商战', '改革', '剧情'],
  },
  {
    id: 'drama-12',
    title: '东京爱情故事',
    category: '日剧',
    categorySlug: 'japanese',
    image: 'https://readdy.ai/api/search-image?query=Classic%20Japanese%20romance%20drama%20poster%20with%20couple%20walking%20in%20Tokyo%20street%20under%20cherry%20blossoms%2C%201990s%20nostalgic%20aesthetic%2C%20warm%20golden%20sunset%20light%2C%20romantic%20film%20poster%20style&width=600&height=800&seq=drama-tokyo-love-12&orientation=portrait',
    rating: 9.2,
    year: 1991,
    region: '日本',
    episodes: '11集全',
    status: '已完结',
    description: '从小城市来到东京的永尾完治，在同事赤名莉香的热情帮助下逐渐适应都市生活。一段纯真而心酸的爱情故事，在繁华的东京街头徐徐展开。',
    actors: ['铃木保奈美', '织田裕二', '有森也实', '江口洋介'],
    director: '永山耕三',
    isHot: false,
    isNew: false,
    updateInfo: '已完结',
    tags: ['爱情', '经典', '都市', '怀旧'],
  },
  {
    id: 'drama-13',
    title: '咒术回战',
    category: '动漫',
    categorySlug: 'anime',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20poster%20with%20young%20sorcerer%20with%20spiky%20hair%20fighting%20demons%2C%20dynamic%20action%20pose%2C%20dark%20supernatural%20background%20with%20cursed%20energy%20effects%2C%20shonen%20anime%20film%20poster&width=600&height=800&seq=drama-jujutsu-13&orientation=portrait',
    rating: 9.0,
    year: 2020,
    region: '日本',
    episodes: '更新至48集',
    status: '连载中',
    description: '高中生虎杖悠仁吞下了诅咒之王两面宿傩的手指，从此踏入了咒术师的世界。在东京都立咒术高等专门学校，他与伙伴们一起对抗诅咒，保护人类。',
    actors: ['榎木淳弥', '内田雄马', '濑户麻沙美', '中村悠一'],
    director: '朴性厚',
    isHot: true,
    isNew: true,
    updateInfo: '每周六更新',
    tags: ['热血', '战斗', '奇幻', '校园'],
  },
  {
    id: 'drama-14',
    title: '鬼灭之刃',
    category: '动漫',
    categorySlug: 'anime',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20poster%20with%20young%20swordsman%20with%20green%20checkered%20haori%20holding%20katana%2C%20snowy%20mountain%20background%2C%20beautiful%20water%20breathing%20effect%2C%20demon%20slayer%20film%20poster%20style&width=600&height=800&seq=drama-demonslayer-14&orientation=portrait',
    rating: 9.1,
    year: 2019,
    region: '日本',
    episodes: '更新至63集',
    status: '连载中',
    description: '大正时代，少年灶门炭治郎全家被鬼杀害，妹妹祢豆子变成了鬼。为了寻找让妹妹恢复成人的方法，他踏上了成为鬼杀队剑士的旅程。',
    actors: ['花江夏树', '鬼头明里', '下野纮', '松冈祯丞'],
    director: '外崎春雄',
    isHot: true,
    isNew: false,
    updateInfo: '剧场版热映中',
    tags: ['热血', '战斗', '奇幻', '历史'],
  },
  {
    id: 'drama-15',
    title: '极限挑战第十季',
    category: '综艺',
    categorySlug: 'variety',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%20with%20six%20celebrities%20in%20colorful%20casual%20outfits%20posing%20dynamically%20in%20urban%20setting%2C%20fun%20and%20energetic%20atmosphere%2C%20reality%20show%20poster%20style&width=600&height=800&seq=drama-jixian-15&orientation=portrait',
    rating: 8.0,
    year: 2024,
    region: '中国大陆',
    episodes: '更新至8期',
    status: '热播中',
    description: '极限男人帮再度集结，在城市中展开一场场充满挑战和欢笑的冒险。每一期都有全新的任务和意想不到的惊喜，展现兄弟间的真挚情谊。',
    actors: ['黄磊', '黄渤', '孙红雷', '王迅', '张艺兴', '迪丽热巴'],
    director: '严敏',
    isHot: false,
    isNew: true,
    updateInfo: '每周日更新',
    tags: ['真人秀', '搞笑', '挑战', '户外'],
  },
  {
    id: 'drama-16',
    title: '王国',
    category: '韩剧',
    categorySlug: 'korean',
    image: 'https://readdy.ai/api/search-image?query=Korean%20historical%20zombie%20drama%20poster%20with%20crown%20prince%20in%20traditional%20hanbok%20holding%20sword%20against%20dark%20palace%2C%20eerie%20atmosphere%2C%20Joseon%20era%20horror%20film%20poster%20style&width=600&height=800&seq=drama-kingdom-16&orientation=portrait',
    rating: 8.5,
    year: 2019,
    region: '韩国',
    episodes: '12集全(共2季)',
    status: '已完结',
    description: '朝鲜王朝时期，国王驾崩后离奇变成丧尸。世子李苍在调查真相的过程中，发现了一场席卷全国的丧尸瘟疫，必须在末日般的灾难中拯救王朝。',
    actors: ['朱智勋', '裴斗娜', '柳承龙', '金相浩'],
    director: '金成勋',
    isHot: false,
    isNew: false,
    updateInfo: '已完结',
    tags: ['古装', '丧尸', '惊悚', '历史'],
  },
];

export const heroBanners = [
  {
    id: 'drama-4',
    title: '庆余年第二季',
    description: '范闲归来，权谋升级！现象级古装大剧第二季，精彩不容错过',
    image: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20fantasy%20drama%20cinematic%20banner%20with%20young%20scholar%20standing%20on%20ancient%20city%20wall%20overlooking%20vast%20palace%20complex%2C%20dramatic%20golden%20sunset%20sky%2C%20flowing%20silk%20robes%2C%20epic%20scale%2C%20warm%20cinematic%20lighting&width=1600&height=700&seq=banner-qingyunian-01&orientation=landscape',
    tag: '热播中',
    rating: 8.9,
  },
  {
    id: 'drama-2',
    title: '狂飙',
    description: '年度爆款！二十年正邪较量，张译张颂文飙戏封神',
    image: 'https://readdy.ai/api/search-image?query=Intense%20Chinese%20crime%20drama%20cinematic%20banner%2C%20two%20men%20facing%20each%20other%20on%20rainy%20city%20street%20at%20night%2C%20neon%20lights%20reflecting%20on%20wet%20pavement%2C%20neo-noir%20cinematography%2C%20dramatic%20moody%20atmosphere&width=1600&height=700&seq=banner-kuangbiao-02&orientation=landscape',
    tag: '高分推荐',
    rating: 8.5,
  },
  {
    id: 'drama-3',
    title: '繁花',
    description: '王家卫首部电视剧，胡歌演绎九十年代上海传奇',
    image: 'https://readdy.ai/api/search-image?query=Retro%20Shanghai%201990s%20cinematic%20banner%20with%20elegant%20couple%20walking%20on%20the%20Bund%20at%20night%2C%20golden%20neon%20signs%2C%20vintage%20cars%2C%20Wong%20Kar-wai%20aesthetic%2C%20romantic%20nostalgic%20atmosphere&width=1600&height=700&seq=banner-fanhua-03&orientation=landscape',
    tag: '经典之作',
    rating: 8.7,
  },
  {
    id: 'drama-6',
    title: '鱿鱼游戏第二季',
    description: '全球现象级韩剧回归！成奇勋重返致命游戏',
    image: 'https://readdy.ai/api/search-image?query=Surreal%20Korean%20drama%20cinematic%20banner%2C%20giant%20colorful%20playground%20structures%20against%20dark%20industrial%20background%2C%20masked%20guards%20in%20pink%20jumpsuits%2C%20ominous%20atmosphere%2C%20high%20contrast%20cinematic%20lighting&width=1600&height=700&seq=banner-squid-04&orientation=landscape',
    tag: '独家热播',
    rating: 8.6,
  },
];